import BasicNumeric from "./BasicNumeric";
export default BasicNumeric;
